/** Preset gráfico escolhido neste navegador e se a medição automática já rodou (item 3.3). */
import { GRAPHICS_PRESET_ORDER, type GraphicsPreset } from "@besenliga/shared";

export const GRAPHICS_KEY = "besenliga.graficos.v1";
export const DEFAULT_PRESET: GraphicsPreset = "medio";

export interface GraphicsChoice {
  preset: GraphicsPreset;
  /** A medição dos primeiros 10 s já rodou (não repete a cada visita). */
  measured: boolean;
}

type Store = Pick<Storage, "getItem" | "setItem">;

export function loadGraphics(store: Store | null): GraphicsChoice {
  try {
    const raw = store?.getItem(GRAPHICS_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : null;
    if (parsed && typeof parsed === "object") {
      const { preset, measured } = parsed as Partial<GraphicsChoice>;
      if (preset && GRAPHICS_PRESET_ORDER.includes(preset)) return { preset, measured: measured === true };
    }
  } catch {
    // Dado corrompido: volta ao padrão.
  }
  return { preset: DEFAULT_PRESET, measured: false };
}

export function saveGraphics(store: Store | null, choice: GraphicsChoice): void {
  try {
    store?.setItem(GRAPHICS_KEY, JSON.stringify(choice));
  } catch {
    // Sem armazenamento: a escolha vale só nesta visita.
  }
}
